import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { Error404Component } from './pages/error404/error404.component';
import {ConfirmComponent} from './private/provider/confirm/confirm.component';

export const routes: Routes = [
  { path: 'vehicle/:selectedVehicle/:selectedCity',loadComponent: () =>
      import('./pages/vehicle-overview/vehicle-overview.component').then((m) => m.VehicleOverviewComponent)},
  { path: 'vehicle/category/:selectedCategory', loadComponent: () =>
      import('./pages/vehicle-overview/vehicle-overview.component').then((m) => m.VehicleOverviewComponent)},
  { path: 'vehicle/category/:selectedCategory/:selectedCity', loadComponent: () =>
      import('./pages/vehicle-overview/vehicle-overview.component').then((m) => m.VehicleOverviewComponent)},
  { path: 'vehicle/:selectedVehicle/:selectedCategory/:selectedCity',loadComponent: () =>
      import('./pages/vehicle-overview/vehicle-overview.component').then((m) => m.VehicleOverviewComponent)},
  { path: 'staff/:staffId', loadComponent: () => import('./pages/staff/staff.component').then(m => m.StaffComponent) },
  { path: 'vehicle-categories', loadComponent: () => import('./pages/vehicle-categories/vehicle-categories.component').then(m => m.VehicleCategoriesComponent) },
  { path: 'news', loadComponent: () => import('./pages/news/news.component').then(m => m.NewsComponent) },
  { path: 'news/:tag', loadComponent: () => import('./pages/news/news.component').then(m => m.NewsComponent) },
  { path: 'news/id/:id', loadComponent: () => import('./pages/news/news.component').then(m => m.NewsComponent) },
  { path: 'testimonials', loadComponent: () =>
      import('./pages/testimonials/testimonials.component').then((m) => m.TestimonialsComponent)},
  { path: 'company-services', loadComponent: () => import('./pages/company-services/company-services.component').then(m => m.CompanyServicesComponent) },
  { path: 'faq', loadComponent: () => import('./pages/faq/faq.component').then(m => m.FaqComponent) },
  { path: 'contact-us', loadComponent: () => import('./pages/contact/contact.component').then(m => m.ContactComponent) },
  { path: 'about-us', loadComponent: () => import('./pages/about-us/about-us.component').then(m => m.AboutUsComponent) },
  { path: 'bio-security', loadComponent: () => import('./pages/bio-security/bio-security.component').then(m => m.BioSecurityComponent) },
  { path: 'onboard', loadComponent: () => import('./pages/onboard/onboard.component').then(m => m.OnboardComponent) },
  { path: 'survey/:id', loadComponent: () =>
      import('./pages/survey/survey.component').then((m) => m.SurveyComponent)},
  { path: 'login', loadComponent: () => import('./pages/login/login.component').then(m => m.LoginComponent) },
  { path: 'forgot-password/:id/:token', pathMatch: 'full', loadComponent: () => import('./pages/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent) },
  { path: 'forgot-password', loadComponent: () => import('./pages/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent) },
  { path: 'change-password', loadComponent: () => import('./pages/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent) },
  { path: 'status/:jwt', loadComponent: () =>
      import( './pages/status/status.component').then((m) => m.StatusComponent)  },
  { path: 'fuec/:fuecid', loadComponent: () => import('./pages/fuec/fuec.component').then(m => m.FuecComponent) },
  { path: 'statusbysms/:jwt',  loadComponent: () =>
      import( './pages/status/status.component').then((m) => m.StatusComponent)  },
  { path: 'booking', loadComponent: () =>
      import('./booking/BookingStepper/booking-stepper.component').then((m) => m.BookingStepperComponent)},
  { path: 'booking/:city',  loadComponent: () =>
      import('./booking/BookingStepper/booking-stepper.component').then((m) => m.BookingStepperComponent)},
  { path: 'chat',  loadComponent: () =>
      import('./chat/chat.component').then((m) => m.ChatComponent)},
  { path: 'chat/:login/:token',  loadComponent: () =>
      import('./chat/chat.component').then((m) => m.ChatComponent)},
  { path: 'payment/:fop/:ref/:currency/:value', loadComponent: () =>
      import('./payment/payment.component').then((m) => m.PaymentComponent)},
  { path: 'payment/index/:index/:fop/:ref/:currency/:value', loadComponent: () =>
      import('./payment/payment.component').then((m) => m.PaymentComponent)},
  { path: 'payment/index/:index/:ref/:currency/:value', loadComponent: () =>
      import('./payment/payment.component').then((m) => m.PaymentComponent)},
  { path: 'payment/:ref/:currency/:value', loadComponent: () =>
      import('./payment/payment.component').then((m) => m.PaymentComponent)},
  { path: 'payment/:ref/:currency', loadComponent: () =>
      import('./payment/payment.component').then((m) => m.PaymentComponent)},
  { path: 'payment/:fop', loadComponent: () =>
      import('./payment/payment.component').then((m) => m.PaymentComponent)},
  { path: 'payment', loadComponent: () =>
      import('./payment/payment.component').then((m) => m.PaymentComponent)},
  { path: 'payment-response/:token', loadComponent: () =>
      import('./payment/payment-response/payment-response.component').then((m) => m.PaymentResponseComponent)},
  { path: 'payment-response', loadComponent: () =>
      import('./payment/payment-response/payment-response.component').then((m) => m.PaymentResponseComponent)},
  {path: 'vehicle', loadComponent: () =>
      import('./fleet/fleet.component').then((m) => m.FleetComponent)}, // eso porque si no se pasa ningun vehiculo, toca ir a la flota general
  {path: 'fleet',  loadComponent: () =>
      import('./fleet/fleet.component').then((m) => m.FleetComponent)},
  {path: 'fleet/:city',  loadComponent: () =>
      import('./fleet/fleet.component').then((m) => m.FleetComponent)},
  {path: 'fleet/:city/:selectedCategory',  loadComponent: () =>
      import('./fleet/fleet.component').then((m) => m.FleetComponent)},
  {path: 'carservice',  loadComponent: () =>
      import('./fleet/fleet.component').then((m) => m.FleetComponent)},
  {path: 'carservice/:city',  loadComponent: () =>
      import('./fleet/fleet.component').then((m) => m.FleetComponent)},
  {path: 'carservice/:city/:selectedCategory',  loadComponent: () =>
      import('./fleet/fleet.component').then((m) => m.FleetComponent)},
  {path: 'limoservice',  loadComponent: () =>
      import('./fleet/fleet.component').then((m) => m.FleetComponent)},
  {path: 'limoservice/:city',  loadComponent: () =>
      import('./fleet/fleet.component').then((m) => m.FleetComponent)},
  {path: 'limoservice/:city/:selectedCategory',  loadComponent: () =>
      import('./fleet/fleet.component').then((m) => m.FleetComponent)},
  {path: 'coverage', loadComponent: () =>
      import( './coverage/coverage.component').then((m) => m.CoverageComponent) },
  {path: 'privacy-policy',  loadComponent: () =>
      import('./pages/privacy-policy/privacy-policy.component').then((m) => m.PrivacyPolicyComponent) , data : { displayCloseButton: false} },
  {path: 'terms-and-conditions', loadComponent: () =>
      import('./pages/term-and-conditions/term-and-conditions.component').then((m) => m.TermAndConditionsComponent), data : { displayCloseButton: false} },
  {path: 'register', loadComponent: () => import('./pages/register/register.component').then(m => m.RegisterComponent)},
  {path: 'registrate', loadComponent: () => import('./pages/register/register.component').then(m => m.RegisterComponent)},
  {
    path: 'private',
    loadChildren: () => import('./private/private.routing').then(m => m.PRIVATE_ROUTES)
  },
  {path: 'provider/confirm/:ref/:token', component: ConfirmComponent}, // Keeping this eagerly loaded as it's part of the authentication flow
  {
    path: 'provider',
    loadChildren: () => import('./private/provider/provider.routing').then(m => m.PROVIDER_ROUTES)
  },
  { path: '', component: HomeComponent }, // Keeping home eagerly loaded as it's the entry point
  { path: 'home', component: HomeComponent }, // Keeping home eagerly loaded as it's the entry point
  { path: '404', loadComponent: () => import('./pages/error404/error404.component').then(m => m.Error404Component) },
  { path: '**', redirectTo: '/404' }
];
